export const OfacSessionHeader = () => {
	return <div className="ofac__header"><span className="ofac__header__icon"><i className="ri-coins-fill"></i></span> Business sanctions and OFAC</div>;
};
